import React from "react";
import styled from "styled-components";
import { Box } from "../Box";
import { Title } from "../Title";
import { Image } from "../Image";
import { Link } from "../Link";
import { Line } from "../Line";
import { IconGridCard } from "../IconGridCard";
import { getIconSelector } from "../../utils/IconSelector";

export interface Props {
  title: string;
  cards: {
    variant: "plug" | "exclaim" | "speech" | "document" | "flame" | "calendar";
    title: string;
    links: {
      linkText: string;
      href: string;
    }[];
  }[];
}

export const Div = styled.div`
  display: inline-block;
`;

// space missing from the theme the sits between t(iny) and m(edium)
const spaceSmall = 24;

export const IconLinksCards: React.FC<Props> = ({ title, cards }) => {
  return (
    <>
      <Title as="h2">{title}</Title>
      <IconGridCard dataTestID="IconLinkCards">
        {cards.map(item => {
          return (
            <Box
              key={title}
              ml={[3, 3, spaceSmall, spaceSmall]}
              mb={[3, 3, spaceSmall, spaceSmall]}
              flex="1 0 50%"
              border="1px solid #BDBDBD"
              boxSizing="border-box"
            >
              <Box margin={4} data-testid="IconLinkCard">
                <Image mb={3} data-testid={`IconLinkCards--${item.variant}`} src={getIconSelector(item.variant)} alt={item.variant} />
                <Title as="h3">{item.title}</Title>
                {item.links.map((link, linksIndex, arr) => {
                  return (
                    <React.Fragment key={link.linkText}>
                      <Link data-testid="IconLinkCard--link" target="_blank" display="block" mt={spaceSmall} fontWeight="500" {...link}>
                        {link.linkText}
                      </Link>
                      {arr.length - 1 !== linksIndex && (
                        <Line mt={spaceSmall} mb={0} opacity={1} display="block" height="1px" bg="#BDBDBD" />
                      )}
                    </React.Fragment>
                  );
                })}
              </Box>
            </Box>
          );
        })}
      </IconGridCard>
    </>
  );
};
